export default "__VITE_ASSET__082f82b9__"